import { FormColumn, Input, RadioGroup } from "best-common-react";
import { RadioValue } from "best-common-react/lib/esm/types";
import React from "react";
import { UITheme, UIThemeOptions, VenueUIConfigOptions, VenueUIConfigOptionsKeys } from "../../types/Config";
import { getStrikeZoneConfig } from "../../util/ConfigUtil";
import YesNoRadioInput from "../form/YesNoRadioInput";
import SlimView from "../slim/SlimView";
import StrikeZoneRender from "../StrikeZoneRender";

type ConfigFormProps = {
  uiConfig: VenueUIConfigOptions;
  onChange: (key: VenueUIConfigOptionsKeys, value: UITheme | string | number | boolean) => void;
  pitchersView?: string;
  isThin?: boolean;
};

const ConfigForm: React.FC<ConfigFormProps> = ({ uiConfig, onChange, pitchersView, isThin = false }) => {
  const prefix = isThin ? "thin" : "full";
  return (
    <div className="row">
      <FormColumn width={2}>
        <div className="row">
          <FormColumn width={2}>
            <div className="row">
              <FormColumn width={1}>
                <RadioGroup
                  id={`${prefix}theme`}
                  name={`${prefix}Theme`}
                  label="Theme"
                  value={uiConfig?.theme}
                  options={UIThemeOptions}
                  onChange={(value: RadioValue | undefined) => {
                    if (!!value) {
                      onChange("theme", value as UITheme);
                    }
                  }}
                  gutterBottom={true}
                />
              </FormColumn>
            </div>
          </FormColumn>
          <FormColumn width={1}>
            <YesNoRadioInput
              id={`${prefix}showPitchSpeed`}
              name={`${prefix}showPitchSpeed`}
              value={uiConfig?.showPitchSpeed}
              onChange={(value) => onChange("showPitchSpeed", value)}
              label="Show Pitch Speed"
              gutterBottom={true}
            />
          </FormColumn>
          <FormColumn width={1}>
            <YesNoRadioInput
              id={`${prefix}showPitchType`}
              name={`${prefix}showPitchType`}
              value={uiConfig?.showPitchType}
              onChange={(value) => onChange("showPitchType", value)}
              label="Show Pitch Type"
              gutterBottom={true}
            />
          </FormColumn>
          <FormColumn width={1}>
            <YesNoRadioInput
              id={`${prefix}showExitVelocity`}
              name={`${prefix}showExitVelocity`}
              value={uiConfig?.showExitVelocity}
              onChange={(value) => onChange("showExitVelocity", value)}
              label="Show Exit Velocity"
              gutterBottom={true}
            />
          </FormColumn>
          <FormColumn width={1}>
            <YesNoRadioInput
              id={`${prefix}showLaunchAngle`}
              name={`${prefix}showLaunchAngle`}
              value={uiConfig?.showLaunchAngle}
              onChange={(value) => onChange("showLaunchAngle", value)}
              label="Show Launch Angle"
              gutterBottom={true}
            />
          </FormColumn>
          <FormColumn width={1}>
            <Input
              id={`${prefix}removePitchIn`}
              value={uiConfig?.removePitchIn}
              onChange={(value) => onChange("removePitchIn", value as number)}
              label="Remove Pitch In (seconds) - time from when pitch is received until it is cleared"
              type="number"
            />
          </FormColumn>
        </div>
      </FormColumn>
      <FormColumn width={2}>
        {isThin ? (
          <SlimView config={getStrikeZoneConfig(uiConfig, pitchersView)} configMode={true} />
        ) : (
          <StrikeZoneRender
            config={getStrikeZoneConfig(uiConfig as VenueUIConfigOptions, pitchersView)}
            configMode={true}
          />
        )}
      </FormColumn>
    </div>
  );
};

export default ConfigForm;
